import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InitialsUpperPipe } from './pipes/initials-upper.pipe';
import { FormApiValidationErrorsComponent } from './components/form-api-validation-errors/form-api-validation-errors.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { translateLoaderFactory } from '../i18n/i18n.module';
import { HttpClient } from '@angular/common/http';
import { GridFiltersComponent } from './dialogs/grid-filters/grid-filters.component';
import { CancelConfirmDialogComponent } from './dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { FiltersChimpComponent } from './components/filters-chimp/filters-chimp.component';
import { GridMenuComponent } from './components/grid-menu/grid-menu.component';
import { ApiModule } from './api/api.module';
import { FilterChimpTextComponent } from './components/filter-chimp-text/filter-chimp-text.component';
import { SendOrdersComponent } from './dialogs/send-orders/send-orders.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { QRDialogComponent } from './dialogs/QRDialog/QRcode-dialog.component';
import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { SuspendPrintComponent } from './dialogs/suspend-resume-print/components/suspend-print/suspend-print.component';
import { ResumePrintComponent } from './dialogs/suspend-resume-print/components/resume-print/resume-print.component';
import { SuspendPdfPrintComponent } from './dialogs/suspend-pdf-print/suspend-pdf-print.component';
import { CustomPaginatorComponent } from '../layout/buttoned-pagination/buttoned-pagination.component';
import { CustomNgxDatetimeAdapter } from './adapters/datetime-adapter';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DuplicateOrdersComponent } from './dialogs/duplicate-orders/duplicate-orders.component';
import { NgChartsModule } from 'ng2-charts';
//import { ReportGenereateDialogComponent } from './dialogs/report-genereate-dialog/report-genereate-dialog.component';
import { ReportFilterDialogComponent } from './dialogs/report-filter-dialog/report-filter-dialog.component';
import { SecondsToTimePipe } from './pipes/seconds-to-time.pip';



@NgModule({
  declarations: [
    SecondsToTimePipe,
    InitialsUpperPipe,
    FormApiValidationErrorsComponent,
    CancelConfirmDialogComponent,
    GridFiltersComponent,
    SendOrdersComponent,
    QRDialogComponent,
    FiltersChimpComponent,
    GridMenuComponent,
    FilterChimpTextComponent,
    MessageDialogComponent,
    SuspendPrintComponent,
    ResumePrintComponent,
    SuspendPdfPrintComponent,
    CustomPaginatorComponent,
    DuplicateOrdersComponent,
    //ReportGenereateDialogComponent,
    ReportFilterDialogComponent,
    //CustomNgxDatetimeAdapter,
  ],
  imports: [
    ApiModule,
    CommonModule,
    FormsModule,
    NgChartsModule,
    MaterialModule,
    LeafletModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    NgxMatDatetimePickerModule, // Add the datetime picker module here
    MatMomentDateModule, // Optionally, add Moment.js date adapter
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    NgxMatDatetimePickerModule, // Add the datetime picker module here
    MatMomentDateModule, // Optionally, add Moment.js date adapter
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    LeafletModule,
    MatDatepickerModule,
    ApiModule,
    FormApiValidationErrorsComponent,
    MaterialModule,
    ReactiveFormsModule,
    SecondsToTimePipe,
    InitialsUpperPipe,
    CancelConfirmDialogComponent,
    MessageDialogComponent,
    GridFiltersComponent,
    TranslateModule,
    FiltersChimpComponent,
    GridMenuComponent,
    CustomPaginatorComponent
  ],
})
export class SharedModule {}
